import moment from "moment/moment";
import { useAppSelector } from "../store/hooks";
import { Booking } from "../interfaces/BookingInterfaces";

const useClientBookings = ({
  clientId
}: {
  clientId: number;
}): { todaysBooking: Booking | undefined } => {
  const bookings: Booking[] = useAppSelector((state) => state.clients.visits);
  const todaysBooking = bookings
    .filter(
      (booking) => booking.clientId === clientId && moment(booking.start).isSame(moment(), "day")
    )
    .sort((a, b) => moment(b.start).valueOf() - moment(a.start).valueOf())[0];

  return { todaysBooking };
};

export default useClientBookings;
